import React from "react";
import "./Navbar.css";
import { useGerenciamento } from "../../Context/GerenciamentoContext";

export default function Navbar() {
  const { novoRegistro, alterarRegistro, itemSelecionado } = useGerenciamento();

  return (
    <div className="Navbar-container">
      <div className="Navbar-menu">
        <button
          className="Navbar-button"
          onClick={novoRegistro}
        >
          Novo
        </button>

        <button
          className="Navbar-button"
          onClick={alterarRegistro}
          disabled={!itemSelecionado}
        >
          Alterar
        </button>
      </div>

      <div className="Navbar-linhabg1"></div>
    </div>
  );
}
